module.exports = __webpack_public_path__ + "media/LibCity_demo.5bc5eb24.mp4";